export default __webpack_public_path__ + "media/images/svg/ico-email-1254c30be936e1623bb2fff861f3dac7.svg";